import React from 'react';
import { cn } from '@/lib/utils';

interface DropdownOption {
  value: string;
  label: string;
  description?: string;
}

interface DropdownProps {
  label: string;
  value: string;
  options: DropdownOption[];
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const Dropdown: React.FC<DropdownProps> = (props) => {
  const {
    label,
    value,
    options,
    onChange,
    error,
    required = false,
    placeholder = "Select an option",
    disabled = false,
    className
  } = props;
  return (
    <div className={cn("space-y-2", className)}>
      <label className="block text-sm font-medium text-foreground">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={cn(
          "w-full px-3 py-2 border rounded-md bg-background text-foreground",
          "focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
          "transition-colors duration-200",
          error 
            ? "border-red-500 focus:ring-red-500" 
            : "border-input hover:border-primary/50",
          disabled && "opacity-50 cursor-not-allowed"
        )}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
      
      {value && options.find(opt => opt.value === value)?.description && (
        <p className="text-sm text-muted-foreground">
          {options.find(opt => opt.value === value)?.description}
        </p>
      )}
    </div>
  );
};

export default Dropdown;
